import { IPoi } from 'src/app/core/poi/poi.model';
import { IGeoPos } from './../../core/geographicalpos/geographicalpos.model';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { select } from '@angular-redux/store';
import { Observable, Subscription, throwError, of } from 'rxjs';
import { ApiService } from '../../services/api.service';
import { Poi } from '../../core/poi/poi.model';
import { PoiActionService } from '../../core/poi/poi.action';
import { TranslateService } from '@ngx-translate/core';
import { catchError, tap, first, mergeMap } from 'rxjs/operators';
import { Themes } from 'src/app/core/themes/themes.model';
import { GeoPos } from 'src/app/core/geographicalpos/geographicalpos.model';
import { MatDialog } from '@angular/material/dialog';
import { AddAttachComponent } from 'src/app/shared/add-attach/add-attach.component';
import { Itin } from 'src/app/core/itinerari/itinerari.model';
import { SuccessRequestComponent } from 'src/app/shared/success-request/success-request.component';
import { FailRequestComponent } from 'src/app/shared/fail-request/fail-request.component';
import { IUser } from 'src/app/core/users/users.model';
import { ItinActionService } from 'src/app/core/itinerari/itinerari.action';
import { Attachments } from 'src/app/core/attachments/attachments.model';
import { AddAvatarComponent } from 'src/app/shared/add-avatar/add-avatar.component';
import { AddVideoComponent } from 'src/app/shared/add-video/add-video.component';
import { CrudAlertService } from 'src/app/services/crud-alert.service';
import { CrudAlertComponent } from 'src/app/shared/crud-alert/crud-alert.component';

@Component({
  selector: 'app-new-itin',
  templateUrl: './new-itin.component.html',
  styleUrls: ['./new-itin.component.scss']
})
export class NewItinComponent implements OnInit, OnDestroy {
  @ViewChild('titleAudio') title_audio: any;
  @ViewChild('avatar') avatar: any;
  @ViewChild('themesSelection') themes_selection: any;
  @ViewChild('geoposSelection') geopos_selection: any;
  @ViewChild('poiSelection') poi_selection: any;
  @ViewChild('picSelection') pic_selection: any;
  @ViewChild('audioSelection') audio_selection: any;
  @ViewChild('docSelection') doc_selection: any;
  @ViewChild('videoSelection') video_selection: any;

  loading = false;
  loadingPoi = false;

  itin_current: Itin = {
    id: null,
    itin_name: {
      it: '',
      sl: '',
      en: '',
    },
    short_descr: {
      it: '',
      sl: '',
      en: '',
    },
    description: {
      it: '',
      sl: '',
      en: '',
    },
    trivia: {
      it: '',
      sl: '',
      en: '',
    },
    attachments: [],
    themes: [],
    geopos: [],
    views: 0,
    pois: [],
    approved: false,
    expanded_panel: false,
    user_id: null
  };

  @select(['poi', 'filtered'])
  poi_list_filtered$: Observable<any>;
  poi_list: Poi[] = [];
  @select(['theme', 'list'])
  themes_list$: Observable<any>;
  themes_list: Themes[] = [];
  @select(['geopos', 'list'])
  geopos_list$: Observable<any>;
  geopos_list: GeoPos[] = [];

  @select(['logged', 'logged'])
  user_logged$: Observable<any>;

  current_lang = 'it';
  user_logged: IUser;
  att_pics: string[] = [];
  att_video: string[] = [];
  att_docs: string[] = [];

  actual_att_selection = [];
  subscriptions: Subscription[] = [];

  constructor(private titleService: Title,
              private apiservice: ApiService,
              private poiAction: PoiActionService,
              private itinAction: ItinActionService,
              private translate: TranslateService,
              private route: Router,
              public dialog: MatDialog,
              private crudAlertService: CrudAlertService) {
    this.translate.setDefaultLang('it');
    if (this.translate.currentLang) {
      this.current_lang = this.translate.currentLang;
      this.translate.use(this.current_lang);
    } else {
      this.translate.use('it');
      this.current_lang = this.translate.currentLang;
    }
    this.translate.get('breadcrumb.new_itin').subscribe((res: string) => {
      this.titleService.setTitle(res + ' - PRIMIS');
    });
    this.translate.onLangChange.subscribe(() => {
      this.current_lang = this.translate.currentLang;
      this.translate.get('breadcrumb.new_itin').subscribe((res: string) => {
        this.titleService.setTitle(res + ' - PRIMIS');
      });
    });
  }

  ngOnInit(): void {
    this.user_logged$.pipe(
      first(),
      mergeMap((user) => {
        this.user_logged = user;
        this.itin_current.user_id = this.user_logged.id;
        if (user.auth_user === 'admin' || user.auth_user === 'editor') {
          const geopos: IGeoPos[] = this.user_logged.geopos;
          this.itin_current.geopos = [...geopos];
          return this.apiservice.getSelectedPoiForItin(geopos[0].id);
        }
        return of(null);
      }),
      tap((poiList: IPoi[]) => {
        if (poiList !== null) {
          this.poiAction.poiList(poiList);
          const geoposSearch = [this.itin_current.geopos[0].name[this.current_lang]];
          this.poiAction.searchPOI(['', [], geoposSearch, this.current_lang]);
        }
      })
    ).subscribe();

    this.subscriptions.push(
      this.themes_list$.subscribe(list => {
        this.themes_list = [...list];
      }),
      this.geopos_list$.subscribe(list => {
        this.geopos_list = [...list];
      }),
      this.poi_list_filtered$.subscribe(list => {
        this.poi_list = [...list];
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    const geoposFilter = this.itin_current.geopos.length > 0 ?
      [this.itin_current?.geopos[0]?.name[this.current_lang]] :
      [];
    this.poiAction.searchPOI([filterValue, [], geoposFilter, this.current_lang]);
  }

  checkGeopos(geopos) {
    if (this.itin_current.geopos.length > 0) {
      return geopos.id === this.itin_current.geopos[0].id;
    } else {
      return false;
    }
  }

  addAtt() {
    const dialogRef = this.dialog.open(AddAttachComponent, {
      width: '450px',
      data: {
        current_lang: this.current_lang
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.itin_current.attachments.push(result);
      }
    });
  }

  addVid() {
    const dialogRef = this.dialog.open(AddVideoComponent, {
      width: '450px',
      data: {
        current_lang: this.current_lang
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.itin_current.attachments.push(result);
      }
    });
  }

  addAva() {
    const dialogRef = this.dialog.open(AddAvatarComponent, {
      width: '450px',
      data: {
        current_lang: this.current_lang
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const avatarIdx = this.itin_current.attachments.findIndex(({avatar}) => avatar);
        if (avatarIdx < 0) {
          this.itin_current.attachments.push(result);
        } else {
          this.itin_current.attachments.splice(avatarIdx, 1, result);
        }
      }
    });
  }

  themesSelectionFunction() {
    this.itin_current.themes = this.themes_selection.selectedOptions.selected.map((opt) => opt._value);
  }

  geoposSelectionFunction() {
    this.loadingPoi = true;
    this.itin_current.geopos = this.geopos_selection.selectedOptions.selected.map((opt) => opt._value);
    const geoposId = this.itin_current.geopos[0].id;
    this.apiservice.getSelectedPoiForItin(geoposId).pipe(
      first(),
      tap((poiList: IPoi[]) => {
        this.poiAction.poiList(poiList);
        this.loadingPoi = false;
      }),
      catchError((err) => {
        console.error('Non è stato possibile recuperare i POI');
        this.loadingPoi = false;
        return of(err);
      })
    ).subscribe();
  }

  poiSelectionFunction() {
    this.itin_current.pois = this.poi_selection.selectedOptions.selected.map((opt) => opt._value);
  }

  attachmentSelectionFunction() {
    const values_selected = [];
    if (this.pic_selection !== undefined) {
      for (const opt of this.pic_selection.selectedOptions.selected) {
        values_selected.push(opt._value);
      }
    }
    if (this.audio_selection !== undefined) {
      for (const opt of this.audio_selection.selectedOptions.selected) {
        values_selected.push(opt._value);
      }
    }
    if (this.doc_selection !== undefined) {
      for (const opt of this.doc_selection.selectedOptions.selected) {
        values_selected.push(opt._value);
      }
    }
    if (this.video_selection !== undefined) {
      for (const opt of this.video_selection.selectedOptions.selected) {
        values_selected.push(opt._value);
      }
    }
    if (this.avatar !== undefined) {
      for (const opt of this.avatar.selectedOptions.selected) {
        values_selected.push(opt._value);
      }
    }

    this.actual_att_selection = [...values_selected];
  }

  remAtt() {
    for (const att of this.actual_att_selection) {
      let index_of_att = this.itin_current.attachments.indexOf(att);
      if (index_of_att > -1) {
        this.itin_current.attachments.splice(index_of_att, 1);
      }
    }
  }

  checkAttachments(att_list: Attachments[], att_type: string) {
    for (const att of att_list) {
      if ((att.file_type === att_type && att_type !== 'picture') ||
        (att.file_type === att_type && att_type === 'picture' && !att.avatar) ||
        (att_type === 'avatar' && att.avatar)) {
        return true;
      }
    }
    return false;
  }

  singleTypeAttachments(att_list: Attachments[], att_type: string) {
    let single_type_list = [];
    for (const att of att_list) {
      if ((att.file_type === att_type && att_type !== 'picture') ||
        (att.file_type === att_type && att_type === 'picture' && !att.avatar) ||
        (att_type === 'avatar' && att.avatar)) {
        single_type_list.push(att);
      }
    }
    return single_type_list;
  }

  saveItin() {
    this.loading = true;
    const itinValidityErrors: string[] = this.crudAlertService.checkItinValidity(this.itin_current);
    if (itinValidityErrors === null) {
      this.apiservice.newItin(this.itin_current).pipe(
        tap((x: any) => {
          if (x && !x.error) {
            this.itinAction.addOrUpdateItin(x);
            this.loading = false;
            const dialogRef = this.dialog.open(SuccessRequestComponent, {
              width: '450px'
            });
            dialogRef.afterClosed().subscribe(() => this.routerFunction('/lista-itinerari'));
          }
        }),
        catchError(error => {
          this.loading = false;
          this.dialog.open(FailRequestComponent, {
            width: '450px'
          });
          return throwError(error);
        })
      ).subscribe();
    } else if (itinValidityErrors?.length > 0) {
      this.loading = false;
      this.dialog.open(CrudAlertComponent, {
        width: '450px',
        data: {
          alertFields: itinValidityErrors
        }
      });
    }
  }

  routerFunction(path_to_new_page) {
    this.route.navigate([path_to_new_page]);
  }

  titleAudioDisabled() {
    return this.itin_current.attachments.some(({title_audio}) => title_audio === true);
  }

  titleAudioSelection() {
    const option_selected = this.title_audio.selectedOptions.selected[0]._value;
    const index = this.itin_current.attachments.indexOf(option_selected);
    this.itin_current.attachments[index].title_audio = true;
  }
}
